import { PROFILE_PATH } from '@/platform/lib/paths';

export const PROFILE_OVERVIEW_PATH = PROFILE_PATH;
export const PROFILE_ACCOUNT_PATH = `${PROFILE_PATH}/konto`;
export const PROFILE_APPEARANCE_PATH = `${PROFILE_PATH}/darstellung`;
export const PROFILE_SECURITY_PATH = `${PROFILE_PATH}/sicherheit`;
export const PROFILE_NOTIFICATIONS_SETTINGS_PATH = `${PROFILE_PATH}/mitteilungen`;
export const PROFILE_DEVICES_PATH = `${PROFILE_PATH}/geraete`;
export const PROFILE_ADMIN_LINKS_PATH = `${PROFILE_PATH}/verwaltung`;

export type ProfileNavLink = {
  id: string;
  label: string;
  to: string;
  end?: boolean;
};
